import { APIService } from '../api';
import { Model } from './Model';

export class Image extends Model {
    public readonly blueprint = Image;
    public readonly endpoint = APIService.createEndpoint('images');

    public thumbnail_path!: string;
    public file_path!: string;
    public file_name!: string;
    public mime_type!: string;
    public extension!: string;
    public width!: number;
    public height!: number;
}
